import styled from "styled-components";

export const SkillsDiv = styled.div`
  height: auto;
  width: 100%;
  background-color: #0d1117;
  /* columns: #ffffff; */

  .title {
    padding-top: 15px;
    color: #ffffff;
    font-size: 35px;
    font-weight: 500;
  }

  .mainContainer {
    width: 80%;
    margin: auto;
    padding: 30px 0 50px;
  }

  .skillsGrid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 2fr));
    justify-content: center;
    justify-items: center;
    gap: 40px;
  }

  .skillsSection {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding: 20px;
    box-sizing: border-box;
    color: #ffffff;
    width: 100%;
    max-width: 320px;
  }

  .skillsListWrapper {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .skillsList {
    list-style: none;
    width: 100%;
    max-width: 360px;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 20px;

    li {
      display: flex;
      align-items: center;
      gap: 15px;
      background-color: #0284c7;
      border-radius: 7px;
      box-sizing: border-box;
      padding: 12px 20px;
      font-size: 16px;
      font-weight: 600;
      color: #ffffff;

      span {
        width: 43px;
        height: 43px;
        border-radius: 5px;
        background-color: #000000;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 28px;
      }

      p {
        margin: 0;
      }
    }
  }
  .subTitle {
    /* border: 1px solid white; */
    padding: 4px 15px;
    border-bottom: 3px solid #e11d48;
    color: #ffffff;
    font-size: 25px;
    width: auto;
    font-weight: 500;
  }

  @media (max-width: 1450px) {
    .mainContainer {
      width: 100%;
    }
  }

  @media (max-width: 1200px) {
    .mainContainer {
      width: 100%;
    }
  }

  @media (max-width: 1040px) {
    .mainContainer {
      width: 100%;
    }
  }

  @media (max-width: 840px) {
    .mainContainer {
      width: 100%;
    }
  }

  @media (max-width: 740px) {
    .skillsGrid {
      grid-template-columns: repeat(auto-fit, minmax(240px, 280px));
      gap: 30px;
    }
  }

  @media (max-width: 640px) {
    .skillsList {
      max-width: 100%;
    }
  }

  @media (max-width: 410px) {
    .skillsList {
      li {
        font-size: 14px;
        padding: 10px 16px;
      }
    }
  }
`;
